<template>
  <div id="page" class="flex-center">
    <div class="main">
      <div class="head text-left">
        <sp-icon type="loginLogo" :size="50" /><span class="sp-color-4" style="opacity: 0.8;font-weight: 700">{{ $l('welcome') }}</span>
        <div class="flex-al-start flex-jc-center pd-l-60 ts-panel">
          <div style="width: 140px;box-sizing: border-box; padding-top: 30px; padding-left: 60px">
            <span class="pointer-svg">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 48" width="32px" height="28px">
                <path stroke-linejoin="round" stroke-width="3" stroke="#000" d="M10.026 40.974v-22h-6v22h6Z" data-follow-stroke="#000" />
                <path stroke-linejoin="round" stroke-width="3" stroke="#000"
                      d="M10.026 18.974c7.123-6.52 11.251-10.26 12.384-11.222 1.7-1.443 3.62-.837 3.62 2.775s-5.285 5.695-5.285 8.447c-.004.016 6.756.017 20.277.003a3 3 0 0 1 3.004 2.998v.003a3.004 3.004 0 0 1-3.004 3.004h-8.01c-1.208 7.973-1.875 12.307-2 13.004-.188 1.044-1.185 2.988-4.054 2.988H10.026v-22Z"
                      clip-rule="evenodd" data-follow-stroke="#686868" />
              </svg>
            </span>
          </div>
          <div class="flex-1">
            <p>Dear user:</p>
            <p class="zw">亲爱的用户：</p>
            <p>It is currently the free trial stage, so we recommend that you send your business card (or complete company information, complete personal information)</p>
            <p class="zw">当前是免费试运行阶段，所以，我们建议你把你的名片（或完整公司信息， 完整个人信息）</p>
            <p>to the <span class="sp-color-14">Callcenter@shiplus.com</span> to apply for a free trial, let us help you register, and then provide you with the username and password of the trial.</p>
            <p class="zw">发到 <span class="sp-color-14">Callcenter@shiplus.com</span>申请免费试用, 由我们帮助你注册登记, 然后提供给你试用的用户名和密码。</p>
          </div>
        </div>
      </div>

      <div class="effect-bg">
        <img src="IMG/effectPic.png">
      </div>
      <div class="card flex-center">
        <LogSignCard />
      </div>
    </div>
  </div>
</template>

<script>
// const LogSignCard = () => import('./logSignCard')
import LogSignCard from './logSignCard.vue'
import spIcon from '@/components/common/SpIcon'
export default {
  name: 'LogAndSign',
  nameSpace: 'LogAndSign',

  components: {
    // LogSignCard: resolve => { require(['./logSignCard'], resolve) }
    LogSignCard,
    spIcon
  },

  data () {
    return {
      user: {}
    }
  },

  computed: {

  },

  methods: {

  }
}
</script>

<style lang="less" scoped>
@side: 50%;
.ts-panel{
  p {
    line-height: 18px;
    margin: 0;
    padding: 0;
    font-size: 18px;
    &.zw{
      font-size: 14px;
      color: #676767;
      margin-top: -4px;
    }
  }
}
#page{
    background:url(~>/IMG/loginBg.png);
    min-width:100%;
    min-height:100%;
    position:absolute;
    left:0;
    top:0;
  background-size: cover;
  >.main{
    .head{
      position: absolute;
      left: 40px;
      top: 24px;
      > *{
        vertical-align: middle;
      }
      > span{
        font-size: 40px;
        padding-left: 20px;
        opacity: 0.6;
      }
    }

    min-width: 100%;
    min-height: 709px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-around;
    align-items: center;
    overflow: hidden;
    >.effect-bg{
      width: @side;
      height:@side;
      flex: 0 1 60%;
      > img{
        position: relative;
        left: -50px;
        top: 38px;
        width: 680px;
        height:100%;
      }
    }
    // > *{
    //   flex: 1 1 auto;
    // }
    > .card{
      flex: 0 1 50%;
      justify-content: flex-start;
    }

  }
}
</style>
